// extracted by mini-css-extract-plugin
export default {"wrapper":"Tooltip_wrapper__dmIof","header":"Tooltip_header__Cf+5g","content":"Tooltip_content__fvO5z"};